import {reactive} from 'petite-vue';

const store = reactive({
  selectedVariant: null,
  variants: [],
  product: null,
  stockSummaryVariants: [],
});

const useVariant = () => {
  return store;
};

const setProduct = (product) => {
  store.product = product;
  store.variants = product.variants;
  const urlParams = new URL(window.location.href).searchParams;
  const variantId = Number(urlParams.get('variant'));
  const variant = store.variants.find((v) => v.id === variantId);

  if (product.has_only_default_variant) {
    store.selectedVariant = {
      ...product,
      id: product.variants[0].id,
    };
    return;
  }

  store.selectedVariant = variant || product.variants[0] || null;
};

const setVariantState = (variantId) => {
  const variant = store.variants.find((v) => v.id === variantId);
  if (!variant) {
    store.selectedVariant = store.variants[0] || null;
    return;
  }

  if (store.selectedVariant?.id === variantId) return;

  store.selectedVariant = variant;
  document.dispatchEvent(new CustomEvent('variant:changed', {detail: variant}));
};
const removeVariantStockSummary = (variantId) => {
  const indexToRemove = store.stockSummaryVariants.findIndex((variant) => variant.id === variantId);
  if (indexToRemove !== -1) {
    store.stockSummaryVariants.splice(indexToRemove, 1);
  }
};

export {useVariant, setProduct, setVariantState, removeVariantStockSummary};
